import styled from "styled-components";

export const StyledAppLogo = styled.div<{ height: number }>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  height: ${({ height }) => height}px;

  & img {
    width: auto;
    object-fit: contain;
    height: ${({ height }) => height - 10}px;

    [dir="rtl"] & {
      margin-right: 0;
      margin-left: 10px;
    }
  }
`;
